// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"109":"b59ec787","932":"0f3730f7"}[chunkId] + ".chunk.css";
};